import {
  INITIAL_CONFIG as BASE_INITIAL_CONFIG,
  type RemoteConfig as BaseRemoteConfig,
  SummarySection as BaseSummarySection,
} from '@web-solutions/base-app/constants/remote-config';
import type { BaseOfferProductTypes } from '@web-solutions/core/constants/remote-config';
import { type Nullable } from '@web-solutions/core/constants/remote-config';
import { InterButtonConfig } from '@web-solutions/core/payment/constants';
import { CoreSummarySection } from '@web-solutions/core/summary/types';

import { type QuizRoute } from './routes';
import type { AfterPurchaseRoutes } from './screens';

enum LocalSummarySection {
  FIND_OUT = 'find_out',
  PLAN = 'plan',
}

export const SummarySection = { ...LocalSummarySection, ...BaseSummarySection };
export type SummarySectionType = LocalSummarySection | BaseSummarySection;

export enum OfferProductId {}

export type OfferProductTypes = BaseOfferProductTypes<OfferProductId>;

export type AfterPurchaseFlow = AfterPurchaseRoutes;

export interface RemoteConfig
  extends Omit<
    BaseRemoteConfig<QuizRoute>,
    'landingStack' | 'landingButtons' | 'emailPageSections' | 'magicType'
  > {
  landingStack: Array<SummarySectionType | CoreSummarySection>;
  landingButtons: Array<InterButtonConfig<SummarySectionType>>;
  emailPageSections: Array<SummarySectionType>;
  afterPurchaseFlow: AfterPurchaseFlow;
  ebookScreenData: any;
  ebookProducts: any;
  mailTemplates: any;
  oneProductBlock: boolean;
  upsaleRoutes: string[];
  unavailableProduct: string[];
}

export const INITIAL_CONFIG: RemoteConfig = {
  ...BASE_INITIAL_CONFIG,
  flow: [],
  consentCookieModal: {
    enabled: false,
    type: 'long',
    placement: 'WELCOME',
  },
  afterPurchaseFlow: [],
  ebookScreenData: [],
  ebookProducts: {},
  mailTemplates: {},
  oneProductBlock: false,
  upsaleRoutes: [],
  unavailableProduct: [],
};

export type FullConfig = Nullable<Partial<RemoteConfig>>;
